import React from "react";

import {
  Container,
  Table,
  Items,
  Item,
  ItemName,
  Complements,
  ComplementsTitle,
  Obs,
  Price,
  ComplementsPrice,
  Restaurant,
} from "./styles";

import formatCompleteDate from "../../../services/formatCompleteDate";

export default function EyeModalOrders({ item, status, done_in }) {
  const userName = item.buyer.phone;
  console.log(item.buyer);

  return (
    <Container>
      <Table>
        <strong>Pedido #{item.attendance_password.password_number}</strong>
      </Table>
      <Restaurant>{item.restaurant.fantasy_name}</Restaurant>
      <Items>
        <Item>
          <ItemName>
            <strong>{item.buyer.name}</strong>
            <Price>{userName}</Price>
          </ItemName>
        </Item>
        <Item>
          <ItemName>
            {item.buyer.email}
            <Price> {formatCompleteDate(item.start_time)}</Price>
          </ItemName>
        </Item>
        <Item style={{ paddingBottom: "5px", borderBottom: "1px solid black" }}>
          <ItemName>
            {done_in !== "-" && `Aceito em ${done_in} min.`}
            <Price>
              <strong>Pedido {status}</strong>
            </Price>
          </ItemName>
        </Item>
        {item.orders.map((order) => (
          <Item key={order.id}>
            <ItemName>
              <strong>
                {order.amount}x {order.product.name}
              </strong>
              <Price>
                <strong>R${order.total_price}</strong>
              </Price>
            </ItemName>
            {order.complement_categories.map((category) => (
              <div key={category.id}>
                <ComplementsTitle>
                  {category.complement_category.name}:
                </ComplementsTitle>
                {category.order_complements.map((complement) => (
                  <Complements key={complement.id}>
                    - {complement.amount}x {complement.complement.name}{" "}
                    <ComplementsPrice>
                      R${complement.complement.price}
                    </ComplementsPrice>
                  </Complements>
                ))}
              </div>
            ))}
            {order.details !== "" && <Obs>Obs: {order.details}</Obs>}
          </Item>
        ))}

        <Item
          style={{ marginTop: 10, borderTop: "1px solid black", color: "red" }}
        >
          <ItemName>
            <strong>Descontos</strong>
            <Price>
              <strong>R${item.discount}</strong>
            </Price>
          </ItemName>
        </Item>
        {item.will_receive_sms && (
          <Item>
            <ItemName>
              <strong>Serviço de SMS</strong>
              <Price>
                <strong>R${item.sms_service_price}</strong>
              </Price>
            </ItemName>
          </Item>
        )}

        <Item>
          <ItemName>
            <strong>Total</strong>
            <Price>
              <strong>R${item.total_price_with_sms}</strong>
            </Price>
          </ItemName>
        </Item>
      </Items>
    </Container>
  );
}
